import React from 'react'

function MsingiTab1() {
  return (
    <div>




<p>Earning that extra degree is not an easy task. Couple it with looking for the money and it can get really messy. Peace of mind is critical in helping you gain the most out of your studies. With Msingi Poa, your peace of mind is assured since it helps you cover the expenses without any worries. How does Msingi Poa help?</p>

-You save for a minimum of 8 years and a maximum of 22 years.<br/>
-The plan pays four lump sum benefits equivalent to 100% sum assured in the last four policy years.  <br/>
-In the last 3 years of the term, no premiums are payable.<br/>
You get tax relief on premiums of 15% for policy terms of at least 10 years<br/>
-After 3 years you can take policy loans of up to 80% of the value of your policy.<br/>




    </div>
  )
}

export default MsingiTab1